import { categoriasPet } from '../../helpers/funcoesAuxiliares';
import { verificarExcecaoPetPorLocalidade } from '../validadoresComunsPorPlano/excecoes';
import { retornaLabelDoValorParentesco, validatorAte64Anos, validatorConjugeMaiorIgual65Anos, validatorDependentesComAdicionalElegivelAte64, validatorDependentesComAdicionalElegivelMaiorIgual65, validatorDependenteSemValorAdicional, validatorDependenteSemValorAdicionalObrigatorio, validatorExConjugeMaiorIgual65, validatorMadrastaMaiorIgual65, validatorMaeMaiorIgual65Anos, validatorMaiorIgual65Anos, validatorPadrastoMaiorIgual65, validatorPaiMaiorIgual65Anos, validatorParentescoEmDuplicidade, validatorParentescosComRegrasEspeciaisAte64 } from './funcoesAuxiliaresZS';

export class CorrenteEdicaoZS {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {
        this.editar = true;
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
        this.maximoDependentesPet = 1;
    }

    infringeParentescoSemAdicional() {
        if (validatorDependenteSemValorAdicional(this.valoresForm)) {
            this.arrayMsgsErro.push('Dependentes do tipo Pais, Filhos, Cônjuge, Sogro (a), Enteados e Adotivos só podem ser inseridos SEM VALOR ADICIONAL.');
        }

        return this;
    }

    infringeParentescosSemValorAdicionalRegrasEspeciais() {
        if (validatorDependenteSemValorAdicionalObrigatorio(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Dependentes do tipo Pais, Filhos, Cônjuge, Sogro (a), Enteados e Adotivos só podem ser inseridos SEM VALOR ADICIONAL.');
        }

        return this;
    }

    infringeParentescoComAdicionalAte64() {
        if (validatorAte64Anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) até 64 anos, o adicional permitido é o ZELO SUPREMO ATÉ 64.');
        }

        return this;
    }

    infringeParentescoComAdicionalMaiorIgual65() {
        if (validatorMaiorIgual65Anos(this.valoresForm)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal) acima de 65 anos, o adicional permitido é o ZELO SUPREMO MAIS 65.');
        }

        return this;
    }

    paiComAdicionalAte64() {
        if (this.valoresForm.Parentesco === '01' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padastro sem adicional e queira adicionar um dependente do tipo Pai até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    paiComAdicionalMaiorIgual65() {
        if (this.valoresForm.Parentesco === '01' && validatorPaiMaiorIgual65Anos(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Padastro sem adicional e queira adicionar um dependente do tipo Pai acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    maeComAdicionalAte64() {
        if (this.valoresForm.Parentesco === '02' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta sem adicional e queira adicionar um dependente do tipo Mãe até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    maeComAdicionalMaiorIgual65() {
        if (this.valoresForm.Parentesco === '02' && validatorMaeMaiorIgual65Anos(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Madrasta sem valor adicional e queira adicionar um dependente do tipo Mãe acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    conjugeComAdicionalAte64() {
        if (this.valoresForm.Parentesco === '10' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge sem valor adicional e queira adicionar um dependente do tipo Esposo(A) até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    conjugeComAdicionalMaiorIgual65() {
        if (this.valoresForm.Parentesco === '10' && validatorConjugeMaiorIgual65Anos(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Ex-Conjuge sem valor adicional e queira adicionar um dependente do tipo Esposo(A) acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    exConjugeComAdicionalAte64() {
        if (this.valoresForm.Parentesco === '32' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) e queira adicionar um dependente do tipo Ex-conjuge até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    exConjugeComAdicionalMaiorIgual65() {
        if (this.valoresForm.Parentesco === '32' && validatorExConjugeMaiorIgual65(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Esposo (a) e queira adicionar um dependente do tipo Ex-conjuge acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    madrastaComAdicionalAte64() {
        if (this.valoresForm.Parentesco === '20007' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Mãe e queira adicionar um dependente do tipo MADRASTA até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    madrastaComAdicionalMaiorIgual65() {
        if (this.valoresForm.Parentesco === '20007' && validatorMadrastaMaiorIgual65(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo Mãe e queira adicionar um dependente do tipo MADRASTA acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    padrastoComAdicionalAte64() {
        if (this.valoresForm.Parentesco === '20008' && validatorParentescosComRegrasEspeciaisAte64(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo tipo Pai e queira adicionar um dependente do tipo PADRASTO até 64 anos é necessário o adicional ZELO ATÉ 64 ANOS.');
        }

        return this;
    }

    padrastoComAdicionalMaiorIgual65() {
        if (this.valoresForm.Parentesco === '20008' && validatorPadrastoMaiorIgual65(this.valoresForm, this.dependentes, this.editar)) {
            this.arrayMsgsErro.push('Caso já exista um dependente do tipo tipo Pai e queira adicionar um dependente do tipo PADRASTO acima de 65 anos é necessário o adicional ZELO MAIOR 65 ANOS.');
        }

        return this;
    }

    parentescosComAdicionalElegivelAte64() {
        if (validatorDependentesComAdicionalElegivelAte64(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro até 64 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO SUPREMO ATÉ 64.');
        }

        return this;
    }

    parentescosComAdicionalElegivelMaiorIgual65() {
        if (validatorDependentesComAdicionalElegivelMaiorIgual65(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Para dependentes do tipo Ex-conjuge, Madrasta e/ou Padastro acima de 65 anos, e que não possuam um dependente de grau equivalente sem valor adicional, é permitido SEM VALOR ADICIONAL ou ZELO SUPREMO MAIS 65.');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro = [`${retornaLabelDoValorParentesco(this.parentesco)}`];
        }

        return this;
    }

    excecaoPetPorLocalidade() {
        if (verificarExcecaoPetPorLocalidade(this.valoresForm.Categoria.trim(), this.valoresForm.Parentesco.trim())) {
            this.arrayMsgsErro = [];
        }

        return this;
    }

    permitirDependentePetSomenteComAdicionalPet() {
        if (this.valoresForm.Parentesco.trim() === 'PET' && !categoriasPet.includes(this.valoresForm.Categoria.trim())) {
            this.arrayMsgsErro.push('Somente é permitido dependente PET que tenha como adicional referente ao PET');
        }

        return this;
    }

    limitarQuantidadePet() {
        const numeroDependentesPet = this.dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === 'PET').length;

        if (this.valoresForm.Parentesco.trim() === 'PET' && this.valoresAnterioresForm.Parentesco !== 'PET') {
            if (numeroDependentesPet >= this.maximoDependentesPet) {
                this.arrayMsgsErro.push(`Só é permitido um dependente do tipo ${this.valoresForm.Parentesco}.`);
            }
        }

        return this;
    }
}
